import * as GQL from "src/types/graphql";

// Flatten nested questions from form template sections
export const flattenFormTemplateQuestions = (
  formTemplate:
    | GQL.GetFormEngineRuleQuestions_form_template_by_pk
    | null
    | undefined
): GQL.GetFormEngineRuleQuestions_form_template_by_pk_sections_questions[] => {
  if (!formTemplate?.sections) return [];

  const allQuestions: GQL.GetFormEngineRuleQuestions_form_template_by_pk_sections_questions[] =
    [];

  for (const section of formTemplate.sections) {
    for (const question of section.questions) {
      // Add the main question
      allQuestions.push(question);

      // Add additional questions from form_question options
      if (question.form_question?.form_question_options) {
        for (const option of question.form_question.form_question_options) {
          if (option.additional_questions) {
            for (const additionalQuestion of option.additional_questions) {
              if (additionalQuestion.question) {
                allQuestions.push(additionalQuestion.question as any);
              }
            }
          }
        }
      }

      // Add grade-specific additional questions
      if (question.grades_question?.grades_additional_questions) {
        for (const gradeAdditional of question.grades_question
          .grades_additional_questions) {
          if (gradeAdditional.question) {
            allQuestions.push(gradeAdditional.question as any);
          }
        }
      }
    }
  }

  return allQuestions;
};
